module.exports = __webpack_public_path__ + "post-listing-block-7-image@2x-KM_uUtB.jpg";